/**
 * Constantes visuais do player.
 * O player usa inline styles (sem Tailwind), então estas constantes
 * centralizam os valores de cor e evitam magic strings espalhadas.
 */
export const PLAYER_COLORS = {
  brand: '#f5c518',
  bgRoot: '#000',
  bgDark: '#0a0a0a',
  bgCard: '#141414',
  bgCardAlt: '#1a1a1a',
  border: '#222',
  borderSubtle: '#333',
  textPrimary: '#fff',
  textMuted: '#777',
  textFaint: '#555',
  textDim: '#444',
  textError: '#ef4444',
  textWarning: '#f59e0b',
  errorBg: '#1a0a0a',
  errorBorder: '#3a1a1a'
} as const
